/**
 * Contingency-fee strings.
 *
 * Help text (h_) was migrated from the inline renderHelpLabel JSX in
 * src/Case/Contingencies/Contingency.tsx — verify against the implementation.
 */
export default {
    d_judgement: 'Judgement',
    h_judgement: 'This is the amount awarded by the court.',

    d_commissionPercentage: 'Commission',
    h_commissionPercentage: 'This is the commission you have negotiated.',

    d_clientPaysExpenses: 'Client Pays Expenses?',
    h_clientPaysExpenses: 'Will the client be paying expenses?',

    d_retainerFee: 'Retainer Fee',
    h_retainerFee: 'If the client is paying a retainer fee, enter the negotiated amount here (uncommon).',
};
